__webpack_require__.p = "https://mini-apps.splittest.ru/";